import { fileIconStyles } from '@/styles/file-icon-styles';
import { Flex, Progress, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { FileIcon } from 'react-file-icon';
const { Text } = Typography;

export default function UploadFileCard({ file }) {
   const [fileSize, setFileSize] = useState(`${file.size} bytes`);

   useEffect(() => {
      if (file.size > 1024) {
         setFileSize(`${Math.round(file.size / 1024)} KB`);
      }
      if (file.size > 1024 * 1024) {
         setFileSize(`${Math.round(file.size / (1024 * 1024))} MB`);
      }
      if (file.size > 1024 * 1024 * 1024) {
         setFileSize(`${Math.round(file.size / (1024 * 1024 * 1024))} GB`);
      }
   }, [file.size]);

   return (
      <>
         <Flex
            vertical
            gap={16}
            align="center"
            style={{ width: '100%', padding: 16, backgroundColor: '#F0F0F0', borderRadius: 4 }}
         >
            <Flex
               gap={32}
               align="center"
               style={{ width: '100%' }}
               justify="space-between"
            >
               <div style={{ width: 32, height: 32 }}>
                  <FileIcon
                     extension={file.name.split('.').pop()}
                     {...fileIconStyles[file.name.split('.').pop()]}
                     style={{ width: 32, height: 32 }}
                  />
               </div>
               <Flex vertical gap={0} align="flex-start" style={{ width: '100%' }}>
                  <Text style={{ fontSize: 14, fontWeight: 500 }}>{file.name}</Text>
                  <Text style={{ fontSize: 12, color: '#999' }}>{fileSize}</Text>
               </Flex>
               <span>{file.status}</span>
            </Flex>
            <Progress type="line" percent={file.percent} size="small" />
         </Flex>
      </>
   );
}
